// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2UUR2","author":"Table_author__2_XPj","authorImage":"Table_authorImage__3P6Fd","unreadRow":"Table_unreadRow__179fa"};